import React from 'react';
import PropTypes from 'prop-types';

import { ChipsItem, Label } from '@atlas/ui';

const SelfExclusionChip = ({ period, selectedPeriod, setSelectedPeriod, text }) => {
  const label = <Label message={text} />;

  const onClick = () => {
    if (period === selectedPeriod) {
      setSelectedPeriod(null);
      return;
    }
    setSelectedPeriod(period);
  };

  return <ChipsItem active={selectedPeriod === period} label={label} onClick={onClick} />;
};

SelfExclusionChip.propTypes = {
  period: PropTypes.number.isRequired,
  selectedPeriod: PropTypes.number,
  setSelectedPeriod: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default SelfExclusionChip;
